export const logoutModalStyles = {
  content: {
    top: "85%",
    left: "20%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "#fff",
    borderRadius: "40px",
    width: "15em",
    minWidth: "5em",
    minHeight: "2em",
  },
  overlay: {
    background: "#9e9e9e69",
  },
};
